import React from "react";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import powerDialerStore from "Stores/powerDialerStore";
import { STATES, leaveCopy } from "Utils/powerDialerMachine";

// Asks before ending a running session (between calls or live); runs onConfirm straight away otherwise.
export const askLeave = onConfirm => {
  const s = powerDialerStore;
  const kind = s.leaveGuard;
  if (kind === "none") return onConfirm();
  const { title, body, action } = leaveCopy(kind, {
    called: s.callLog.length,
    total: s.dialableCount,
    name: s.current?.name || ""
  });
  s.clearTimer("countdown");
  s.clearTimer("autolog");
  confirmationPopupState.setPopupValues({
    cancelCbk: () => {
      s.state === STATES.COUNTDOWN && s.startCountdown();
      s.state === STATES.AUTOLOG && s.startAutoLog();
    },
    content: (
      <div className="pdPopup">
        <div className="pdPopupTitle">{title}</div>
        <div className="pdPopupText">{body}</div>
      </div>
    ),
    dynamicDom: true,
    actionBtnText: action,
    cancelBtnText: "Stay",
    callback: () => {
      s.leave();
      onConfirm();
    }
  });
  confirmationPopupState.setShowPopup(true);
};
